// src/components/layout/Layout.jsx

import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useStore } from '../../store/useStore';
import { usePageTitle } from '../../context/PageTitleContext';

const pageConfig = {
  '/dashboard': {
    title: 'Dashboard',
    subtitle: 'Fleet overview and key metrics',
  },
  '/map': {
    title: 'Live Tracking',
    subtitle: 'Real-time vessel positions',
  },
  '/playback': {
    title: 'Trip Playback',
    subtitle: 'Replay vessel voyages',
  },
  '/fuel': {
    title: 'Fuel Monitor',
    subtitle: 'Fuel consumption analysis',
  },
  '/sensors': {
    title: 'Sensor Monitor',
    subtitle: 'Real-time sensor data',
  },
  '/vessels': {
    title: 'Vessel Management',
    subtitle: 'Manage fleet vessels',
  },
  '/vessels/register': {
    title: 'Register Vessel',
    subtitle: 'Add new vessel to fleet',
  },
  '/companies': {
    title: 'Company Management',
    subtitle: 'Manage companies',
  },
  '/users': {
    title: 'User Management',
    subtitle: 'Manage system users',
  },
  '/reports': {
    title: 'Reports',
    subtitle: 'Generate and export reports',
  },
  '/settings': {
    title: 'Settings',
    subtitle: 'Account and preferences',
  },
};

const Layout = () => {
  const { sidebarCollapsed } = useStore();
  const location = useLocation();
  const { updatePageTitle } = usePageTitle();

  useEffect(() => {
    let config = pageConfig[location.pathname];

    if (!config) {
      if (location.pathname.startsWith('/playback/')) {
        config = {
          title: 'Trip Playback',
          subtitle: 'Viewing trip details',
        };
      } else if (
        location.pathname.startsWith('/vessels/') &&
        location.pathname !== '/vessels' &&
        location.pathname !== '/vessels/register'
      ) {
        config = {
          title: 'Vessel Details',
          subtitle: 'View vessel information',
        };
      } else {
        config = {
          title: 'Fuel Monitor',
          subtitle: 'Fleet fuel management',
        };
      }
    }

    updatePageTitle(config.title, config.subtitle);
  }, [location.pathname, updatePageTitle]);

  return (
    <div className="min-h-screen bg-surface-50 dark:bg-surface-950">
      <Sidebar />

      <div
        className={`
          transition-all duration-300 ease-in-out
          ${sidebarCollapsed ? 'lg:ml-[68px]' : 'lg:ml-[240px]'}
        `}
      >
        <Header />

        <main className="p-3 lg:p-4">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;